export const VEHICLE_BRANDS_LIST_ALL = "VEHICLE_BRANDS_LIST_ALL";
export const VEHICLE_BRANDS_LIST_ALL_SUCCESS = "VEHICLE_BRANDS_LIST_ALL_SUCCESS";
export const VEHICLE_BRANDS_LIST_ALL_ERROR = "VEHICLE_BRANDS_LIST_ALL_ERROR";
export const VEHICLE_BRANDS_LIST_ALL_RESET = "VEHICLE_BRANDS_LIST_ALL_RESET";
